import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterData } from '../filter-data';
import * as _moment from 'moment';
import {AppComponent} from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
export class DisplayData {
  UserID: string;
  ReportID: string;
  DefaultValue1: string;
}
export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
    selector: 'app-viewfilter',
    templateUrl: './viewfilter.component.html',
    styleUrls: ['./viewfilter.component.css'],
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class ViewfilterComponent implements OnInit {
  @Input() formData: FilterData[];
  form: FormGroup;
  submitted: boolean = false;
  minDate = new Date(1990, 0, 1);
  maxDate = new Date(2030, 0, 1);
  pageurl: string;
  url: string;
  ReportID: any;
  buttonName: string = 'View';
  ID: any;
  editable: boolean;
  SelectedValue: any;
  SelectedValue2: any;
  SelectedValue3: [];
  ShowID: number = 1;
  PassFlow: any;
  PassStatus: any;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) { this.url = AppComponent.baseURL; }


  ngOnInit() {
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    if(pagehead[2].includes("~"))
    {
      let filterData  =pagehead[2].split('~');
      this.ReportID = filterData[0];
      this.PassFlow =  filterData[1];
      this.PassStatus = filterData[2];

    }
    else
    {
      this.ReportID = pagehead[2];
    }
    this.ShowID=1;
    if(this.ReportID=='207069000'||this.ReportID=='202018000'){this.ShowID=0;}
    const formGroup = {};
    this.form = new FormGroup(formGroup);
    this.buttonName = "View";
   // this.form = this.formBuilder.group({ ID:['']});
   this.http.get(this.url + 'filter/GetfilterDesign?ReportID=' + this.ReportID)
      .subscribe((res: any) => {
        this.formData = JSON.parse(res.toString());
        this.buildFormFromDefinition();
      });
    // this.http.get(this.url + 'filter/GetfilterDesign?ReportID=' + this.ReportID)
    // .subscribe( (res) => {
    //   this.formData = JSON.parse(res.toString());
    //                       // console.log(JSON.parse(res.toString()));

    //                        this.formData.forEach(formControl => {
    //                           formGroup[formControl.controlName] = new FormControl("");
    //                           if (formControl.controlName2 != "") {
    //                           formGroup[formControl.controlName2] = new FormControl(""); }
    //                           this.form = new FormGroup(formGroup);
    //                         });
    //                        for (var val of JSON.parse(res.toString())) {
    //                           this.SelectedValue = val.selectedValue;
    //                           this.SelectedValue2 = val.selectedValue2;
    //                           this.SelectedValue3 = val.selectedValue3;
    //                           if(val.controlName == "HLPNoticeType" && this.PassStatus == undefined)
    //                             this.PassStatus = this.SelectedValue;
    //                             if(val.controlName == "HLPNoticeType" && this.PassStatus == "undefined")
    //                               this.PassStatus = this.SelectedValue;
    //                          if (val.controlType == "DTP2") { if (this.SelectedValue == "") {
    //                           let date: Date = new Date();
    //                           this.SelectedValue = date;
    //                           this.SelectedValue2 = date; }
    //                          }
    //                             (this.form.get(val.controlName) as FormControl).patchValue(this.SelectedValue);
    //                             if (val.controlName2 != "") {
    //                               (this.form.get(val.controlName2) as FormControl).patchValue(this.SelectedValue2); }
    //                               if (val.controlType == "HLP") {
    //                                (this.form.get(val.controlName) as FormControl).patchValue(this.SelectedValue3);
    //                                }

    //                         }
    //                       } );
  }
   private buildFormFromDefinition() {
    const group: { [key: string]: FormControl } = {};

    (this.formData || []).forEach(fd => {
      // initial value selection
      let initialValue: any = null;
      if (fd.controlType === 'HLP') {
        // multi-select: ensure array
        initialValue = fd.selectedValue3 && fd.selectedValue3.length ? fd.selectedValue3 : [];
      } else if (fd.controlType === 'DTP2') {
        // date default handling: if empty, put today's date
        initialValue = fd.selectedValue ? new Date(fd.selectedValue) : null;
      } else {
        initialValue = fd.selectedValue !== undefined && fd.selectedValue !== '' ? fd.selectedValue : null;
      }

      // Collect validators
      const validators = [];
      if (fd.validators) {
        if (fd.validators.required) validators.push(Validators.required);
        if (fd.validators.minlength) validators.push(Validators.minLength(fd.validators.minlength));
        if (fd.validators.maxlength) validators.push(Validators.maxLength(fd.validators.maxlength));
      }

      // Add control
      group[fd.controlName] = new FormControl(initialValue, validators);

      // If there is a second control (controlName2), create it as well
      if (fd.controlName2) {
        const init2 = fd.selectedValue2 ? fd.selectedValue2 : null;
        const validators2 = [];
        // reuse same validator scheme if needed
        if (fd.validators) {
          if (fd.validators.required) validators2.push(Validators.required);
          if (fd.validators.minlength) validators2.push(Validators.minLength(fd.validators.minlength));
          if (fd.validators.maxlength) validators2.push(Validators.maxLength(fd.validators.maxlength));
        }
        group[fd.controlName2] = new FormControl(init2, validators2);
      }
    });

    this.form = new FormGroup(group);
  }
    hasError(controlName: string): boolean {
    const c = this.form.get(controlName);
    return !!(c && c.invalid && (c.dirty || c.touched));
  }
  submitForm() {
  //  parent.postMessage('message',document.location.href);

  parent.postMessage({
    event_id: 'message',
    data: {
      Param: JSON.stringify(this.form.value)}
    }, document.location.href);
  this.submitted = true;
  this.http.post(this.url + 'filter/InsertUpdateGetMaster', this.form.value).subscribe( (data) =>   {
        if (data == null) {
          this.alertService.showError('Check Your InterNet Connection, Try Again Later');
        }
       }
    );
  }
  configureReport() {

  parent.postMessage({
      event_id: 'message',
      data: {
        Param: JSON.stringify(this.form.value)}
      }, document.location.href);
    this.submitted = true;
    this.http.post(this.url + 'filter/InsertUpdateGetMaster', this.form.value).subscribe( (data) =>   {
          if (data == null) {
            this.alertService.showError('Check Your InterNet Connection, Try Again Later');
          }
          else{
            this.http.get(this.url + 'filter/GetfilterValue?ReportID=' + this.ReportID)
            .subscribe( (res) => {
              let filterValue: DisplayData[] = JSON.parse(res.toString());
              localStorage.setItem('filterValue', filterValue[0].DefaultValue1); });
              window.open("configurereport/" + this.ReportID+"/0",'_blank');
          }
         }
      );


    }
}
